// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"77f2dbe9","393":"c9b82206","447":"c4d49b7c","455":"1bcc1573","967":"bc631278","977":"4bcab452"}[chunkId] + ".chunk.js";
};